// extracted by mini-css-extract-plugin
export var divider = "_gi-7";
export var itemsToggle = "_gi-8";
export var mergeModal = "_gi-1";
export var optionCard = "_gi-4";
export var radioGroup = "_gi-6";
export var radioOption = "_gi-0";
export var selected = "_gi-5";
export var shipmentOptions = "_gi-2";
export var tableOptions = "_gi-3";